import { render } from "./NotaSpese.vue?vue&type=template&id=c81c846c&scoped=true&ts=true"
import script from "./NotaSpese.vue?vue&type=script&lang=ts"
export * from "./NotaSpese.vue?vue&type=script&lang=ts"

import "./NotaSpese.vue?vue&type=style&index=0&id=c81c846c&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_save-group_1779204252500559514/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c81c846c"]])

export default __exports__